import { addOptionsToDropdown, updatePaymentTypes } from '@engine/features/virtual_terminal/vt_update_payment_types';

function updateOnlineBankingBankCodes(banks) {
  var selectedBank = $('#online_banking_transaction_bank_code option:selected').val();
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';
  $('#online_banking_transaction_bank_code').empty();
  $('#online_banking_transaction_bank_code').append(emptyValue);

  if (Object.keys(banks).length === 0) {
    $('.bank-code').addClass('hidden');
  } else {
    addOptionsToDropdown('#online_banking_transaction_bank_code', banks, selectedBank);
    $('.bank-code').removeClass('hidden');

    if (selectedBank === 'BLK') {
      $('.auth_code').removeClass('hidden');
    }
  }

  $('.for_chosen').trigger('chosen:updated');
}

function updateOnlineBankingPaymentTypes(paymentTypes) {
  updatePaymentTypes(paymentTypes, 'online_banking');
}

function listenForBankCodeChange() {
  $('#online_banking_transaction_bank_code').on('change', function () {
    var selectedBankCode = $('#online_banking_transaction_bank_code option:selected').val();

    if (selectedBankCode === 'BLK') {
      $('.auth_code').removeClass('hidden');
    } else {
      $('.auth_code').addClass('hidden');
    }
  });
}

export default {
  updateBankCodes: updateOnlineBankingBankCodes,
  updatePaymentTypes: updateOnlineBankingPaymentTypes,
  updateBlikMandatoryField: listenForBankCodeChange
};